import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c3aec92&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0c3aec92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3aec92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3aec92')) {
      api.createRecord('0c3aec92', component.options)
    } else {
      api.reload('0c3aec92', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c3aec92&scoped=true", function () {
      api.rerender('0c3aec92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/customInput/index.vue"
export default component.exports